export const MAX_CATEGORIES = 2;
export const MAX_CATEGORIES_FROM_EDIT = 1;
export const ADD_ATTRIBUTE_VARIANT_VIEW = 'ADD_ATTRIBUTE_VARIANT_VIEW';
export const ADD_ATTRIBUTE_VIEW = 'ADD_ATTRIBUTE_VIEW';
export const ADD_VARIANT_VIEW = 'ADD_VARIANT_VIEW';
